import { Component, Input, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { FormService } from '../../services/form.service';
import { AppService } from 'src/app/app.service';
import { DhlFormControl } from '../../models/dhl-form-control';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { DhlFormControlEvent } from '../../models/dhl-form-control-event';
import { DhlFormControlEventData } from '../../models/dhl-form-control-event-data';
@Component({
    selector: 'app-form-field-button',
    templateUrl: './form-field-button.component.html',
    styleUrls: ['./form-field-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FormFieldButtonComponent implements AfterViewInit {
  
  @Input() configData: DhlFormControl;
  @Input() frmGroup: UntypedFormGroup;

  validationType: string = '';
  isSpinnerShow: boolean = false;
  confirmDlg: MatDialogRef<ModalComponent>;
  constructor(private formService: FormService, private appService: AppService, public matDialog: MatDialog) { }

  get f() { return this.frmGroup.controls; }

  ngAfterViewInit() {
    let form = this.frmGroup.get(this.configData.name)
  }
  resetBtnClick(){
  }
  submitBtnClick(){
    this.onCommonEventHander('GET_CURRENT_USR_DETAILS')
  }
  onCommonEventHander(eventType) {
    console.log("event type",eventType)
    let event: DhlFormControlEvent | null = this.checkEventExist(this.configData.events, eventType);
    if (event) {
      this.sendToSource(event, null);
      return
    }

  }

  /** Common Method to check event exist in template */
  checkEventExist(events, eventName): DhlFormControlEvent | null {
    let event = null;
    if (events && Array.isArray(events)) {
      event = events.filter(ele => ele.event == eventName);
      event = (event.length ? event[0] : null);
    }
    return event;
  }

  sendToSource(event: DhlFormControlEvent, data = {}) {
    let eventData: DhlFormControlEventData = {
      event: event.event,
      eventData: event,
      action: event.action,
      name: this.configData.name,
      component: this,
      configData: this.configData,
      data: data,
    }
    this.appService._commonComponentSubject.next(eventData);
  }

}
